/*
 *   File : add-regex-modal.js
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations : 
 *   Version : 1.0.0
*/

import jsonlint from "jsonlint-mod";
import React, { memo, useEffect, useState } from 'react';
import { toast } from 'react-toastify';


// Custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomTextArea } from '../FormElements';
import { APIService } from '../../Service';


const AddRegexConfigModal = ({ fieldData, handleClose, onUpdate, corridorId, channelId }) => {


    const [loading, setLoading] = useState(false);
    const [editStatus, setEditStatus] = useState(false);

    const [description, setDescription] = useState("");
    const [descriptionError, setDescriptionError] = useState("");

    useEffect(() => {
        var edit_modal = document.getElementById("add-regex-config-modal");
        edit_modal.addEventListener("hidden.bs.modal", () => {
            setEditStatus(false);
        });
    }, []);

    useEffect(() => {
        setDescriptionError("");
    }, [description]);

    useEffect(() => {
        if (fieldData && fieldData.regex) {
            console.log(fieldData, "data");
            setDescription(fieldData.regex); // prefill with existing regex
            setEditStatus(true); // optional: track edit mode
        } else {
            setDescription(""); // new regex
            setEditStatus(false);
        }
    }, [fieldData]);

    // handle close Modal 
    const _handleCloseModal = () => {
        var button = document.getElementById("add-regex-config-modal-close");
        button.click();
        setEditStatus(false);
        handleClose();
    };


    // handle submit new password

    // const _validateRegex = () => {
    //     setDescriptionError("");
    //     const input = description.trim();

    //     if (input.length === 0) {
    //         setDescriptionError("JSON input is required");
    //         return;
    //     }

    //     // Step 1: Validate JSON syntax using jsonlint
    //     try {
    //         jsonlint.parse(input); // throws detailed syntax errors with line/column
    //     } catch (e) {
    //         setDescriptionError(`Syntax error: ${e.message}`);
    //         return;
    //     }

    //     // Step 2: Optional: check that it is a JSON object (not required)
    //     let parsed;
    //     try {
    //         parsed = JSON.parse(input);
    //     } catch {
    //         setDescriptionError("Invalid JSON object");
    //         return;
    //     }

    //     if (typeof parsed !== "object" || Array.isArray(parsed)) {
    //         setDescriptionError("JSON must be an object or array");
    //         return;
    //     }

    //     // Step 3: Valid — send exactly what user typed
    //     _handleRegexField(input);
    // };

    const _validateRegex = () => {
        setDescriptionError("");
        const input = description.trim();

        if (!input.length) {
            setDescriptionError("JSON input is required");
            return;
        }

        // Step 1: JSON SYNTAX CHECK
        try {
            jsonlint.parse(input);
        } catch (e) {
            setDescriptionError(`Syntax error: ${e.message}`);
            return;
        }

        // Step 2: Parse JSON
        let parsed = null;
        try {
            parsed = JSON.parse(input);
        } catch {
            setDescriptionError("Invalid JSON object");
            return;
        }

        // Must be an object
        if (typeof parsed !== "object" || Array.isArray(parsed)) {
            setDescriptionError("JSON must be an object");
            return;
        }

        // Step 3: Validate "pattern" field if it exists
        if (parsed.pattern !== undefined) {
            if (typeof parsed.pattern !== "string") {
                setDescriptionError(`"pattern" must be a string`);
                return;
            }

            // Try compiling the regex
            try {
                new RegExp(parsed.pattern);
            } catch (e) {
                setDescriptionError(`Invalid regex syntax: ${e.message}`);
                return;
            }
        }

        // All good — move forward
        _handleRegexField(input);
    };



    const _handleRegexField = (jsonInput) => {
        setLoading(true);
        const url = "field-mapping/add-regex";

        const data = {
            master_id: fieldData.master_id,
            corridor_id: corridorId,
            channel_id: channelId,
            regex: jsonInput //  send exactly what user typed
        };

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast"
                });
                onUpdate(); // or pass updated regex to dashboard
                _handleCloseModal();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error", className: "e-toast"
                });
            }
            setLoading(false);
        });
    };


    return (
        <div className="modal fade" id="add-regex-config-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="confirmDeleteModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered ">
                <div className="modal-content e-border-radius-28 w-400px mx-auto ">
                    <img src={require("../../Assets/Images/Home/close.svg").default}
                        draggable={false}
                        className='d-none'
                        id='add-regex-config-modal-close'
                        alt='close'
                        data-bs-dismiss="modal" />
                    <div className="modal-header px-4 pt-4 pb-3 border-0 align-items-start justify-content-space-between">


                        <h4 className='mb-0 e-primary-font e-text-raisin-black e-font-16 e-font-weight-600 line-height-28px'>
                            Add Regex
                        </h4>
                        <img src={require("../../Assets/Images/Home/close.svg").default}
                            draggable={false}
                            alt='close'
                            className='cursor-pointer'
                            onClick={_handleCloseModal} />

                    </div>
                    <div className="modal-body px-4 pb-2 pt-0">
                        <>

                            <CustomTextArea placeholder={`Eg:  {
  "pattern": "^[A-Za-z0-9]+$",
  "description": "Allows only alphanumeric characters"
}
`}
                                // label="Add regex"
                                rows={8}
                                cols={40}
                                type="text"
                                require
                                value={description}
                                error={descriptionError}
                                autoFocus={true}
                                className="w-100"
                                labelStyle="e-font-weight-400"
                                // heightClassName="h-100px"
                                handleChange={(e) => setDescription(e)}
                            />


                            {/* Custom button  */}
                            <div className='row row-cols-2 pt-2 mt-2 pb-3'>
                                <div className='col'>
                                    <SecondaryButton name="Cancel"
                                        className="w-100"
                                        onPress={_handleCloseModal} />
                                </div>
                                <div className='col'>
                                    <PrimaryButton name="Create"
                                        className="w-100 e-bg-primary-blue"
                                        status={loading}
                                        onPress={_validateRegex}
                                    />
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </div>

    )
}

AddRegexConfigModal.defaultProps = {
    handleClose: () => { }
}

export default memo(AddRegexConfigModal);